import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import AppText from "../../Core/AppText/AppText";
import Button, { ButtonStyleProps } from "../../Core/Button/Button";
import { useConfirmModalStore } from "../../../stores/confirmModal.store";

interface ModalStyles {
	primaryActionButton?: ButtonStyleProps;
	secondaryActionButton?: ButtonStyleProps;
	thirdActionButton?: ButtonStyleProps;
}

const ConfirmationModal: React.FC = () => {
	const modalStore = useConfirmModalStore();
	const { modalData } = modalStore;
	const { t } = useTranslation();

	const [modalStyle, setModalStyle] = useState<ModalStyles>();

	useEffect(() => {
		const defaultGrayButton: ButtonStyleProps = {
			backgroundColor: "dividerGray",
			textColor: "black",
		};

		switch (modalData.type) {
			case "DANGER":
				setModalStyle({
					primaryActionButton: {
						backgroundColor: "danger",
						textColor: "white",
					},
					secondaryActionButton: {
						...defaultGrayButton,
					},
				});
				break;
			default:
				setModalStyle({
					secondaryActionButton: {
						...defaultGrayButton,
					},
				});
		}
	}, [modalData.type]);

	return (
		<ModalContainer>
			<ModalWrapper>
				{modalData.form ? (
					modalData.form
				) : (
					<>
						<AppText size="xm" weight="bold">
							{modalData.title && t(modalData.title as any)}
						</AppText>
						{typeof modalData.text === "string" ? (
							<AppText margin="1.5rem 0 2rem 0" textAlign="center">
								{modalData.text && t(modalData.text as any)}
							</AppText>
						) : (
							modalData.text
						)}
					</>
				)}
				{modalData.body ? modalData.body : null}
				<Button
					width="12.625rem"
					{...modalStyle?.primaryActionButton}
					margin="0 0 0.5rem 0"
					onClick={() => modalStore.onAccept()}
				>
					{modalData.acceptButtonText && t(modalData.acceptButtonText as any)}
				</Button>
				<Button
					width="12.625rem"
					{...modalStyle?.secondaryActionButton}
					onClick={() => modalStore.onReject()}
				>
					{modalData.rejectButtonText && t(modalData.rejectButtonText as any)}
				</Button>
			</ModalWrapper>
		</ModalContainer>
	);
};

export default ConfirmationModal;

const ModalContainer = styled.div`
	position: fixed;
	z-index: 1000;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	background: rgba(0, 0, 0, 0.6);
	overflow-y: auto;
`;

const ModalWrapper = styled.section`
	background: white;
	width: 100%;
	max-width: 32.5rem;
	margin: 10em auto 5em auto;
	height: auto;
	align-items: center;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	padding: 3.125rem;
`;
